// Roman numeral chapter mark used above section headings.
// e.g. <ChapterMark n={1} label="Manifesto" />
const ROMAN = ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];

export default function ChapterMark({ n, label }) {
  return (
    <div className="flex items-baseline gap-4 sm:gap-6 font-mono text-[10px] sm:text-xs uppercase tracking-[0.28em] text-neutral-500">
      <span className="chapter-mark not-italic text-[#FF6A1A] text-3xl sm:text-4xl leading-none italic">
        {ROMAN[n] || n}
      </span>
      <span className="h-px w-10 sm:w-16 bg-neutral-700" />
      <span>Chapter · {label}</span>
    </div>
  );
}
